import { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
 
function ProfileDropdown({ show, onClose }) {
  const ref = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  if (!show) return null;

  const logoutHandler = () => {
    try {
      localStorage.removeItem("access_token");
      localStorage.getItem("available_tokens")
      localStorage.removeItem("isAuthUser");
      localStorage.removeItem("isAdminUser");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("dashboardTab");
      localStorage.removeItem("userProfileInfo");
      localStorage.removeItem("registerEmail");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      // dispatch(fetchUserSuccess({}));
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
 
  return (
    <div
      ref={ref}
      className="absolute z-30 right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl py-2 px-0"
      style={{
        top: "100%",
        minWidth: "210px",
        boxShadow:
          "0 12px 32px 0 rgba(44, 55, 130, 0.13), 0 1.5px 5px 0 rgba(44, 55, 130, 0.07)",
      }}
    >
      <ul className="flex flex-col">
        {/* <li>
          <button
            onClick={() => {
              onClose();
            }}
            className="w-full text-left px-6 py-3 hover:bg-[#f6fafe] font-semibold text-[#223056] text-[17px] leading-snug transition-colors"
          >
            My Picks
          </button>
        </li> */}
        <li>
          <button
            onClick={() => {
              navigate("/profile");
              onClose();
            }}
            className="w-full text-left font-archivo px-6 py-3 hover:bg-[#f6fafe] font-semibold text-[#223056] text-[17px] leading-snug transition-colors"
          >
            My Profile
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              navigate("/help");
              onClose();
            }}
            className="w-full text-left font-archivo px-6 py-3 hover:bg-[#f6fafe] font-semibold text-[#223056] text-[17px] leading-snug transition-colors"
          >
            Help
          </button>
        </li>
        <li>
          <button
            onClick={() => {
               localStorage.removeItem("available_tokens")
              logoutHandler();
            }}
            className="w-full text-left font-archivo px-6 py-3 hover:bg-[#f6fafe] font-semibold text-[#223056] text-[17px] leading-snug transition-colors"
          >
            Log out
          </button>
        </li>
      </ul>
    </div>
  );
}
 
export default ProfileDropdown;